<template>
  <div class="system">
    <div class="product">
      <div class="name">产品体系</div>
      <div class="lable">国产自主可控区块链技术领军者</div>
      <div class="content">
        <div class="contentNames">
          <div
            v-for="(item, index) in nameList"
            class="nameFor"
            @mouseenter="systemIndex = index"
            :class="{ active: index === systemIndex }"
          >
            <span>
              <img
                src="./../../assets/home/system.png"
                alt=""
                v-show="systemIndex === index"
              />
              {{ item }}
            </span>
          </div>
        </div>
        <div
          class="contentLable"
          v-for="(item, index) in lableList"
          v-show="systemIndex === index"
        >
          <div class="lableLeft">
            <div v-for="item1 in item.leftList">
              <img :src="item1.url" alt="" />
              <span>{{ item1.name }}</span>
            </div>
          </div>
          <div class="lableRight">
            <div v-for="item2 in item.rightList">
              <img src="./../../assets/home/lableRight.png" alt="" />
              <span>{{ item2 }}</span>
            </div>
          </div>
        </div>
        <div class="nan">
          <div class="nanleft">
            <!--                        应用产品-->
          </div>
          <div class="nanright">
            <!--                        应用平台-->
          </div>
        </div>
      </div>
      <div class="bgc"></div>
      <div class="img">
        <img src="./../../assets/home/system.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-system",
  data() {
    return {
      nameList: [
        "区块链边缘层",
        "区块链基础设施",
        "区块链服务平台",
        "区块链行业应用",
      ],
      systemIndex: 0,
      lableList: [
        {
          leftList: [
            {
              url: require("./../../assets/home/lableRight.png"),
              name: "区块链芯片MTChip",
            },
            {
              url: require("./../../assets/home/lableRight.png"),
              name: "区块链物联网设备MTIoT",
            },
          ],
          rightList: ["区块链模组MTCard", "区块链分布式存储设备HashStor"],
        },
        {
          leftList: [
            {
              url: require("./../../assets/home/lableRight.png"),
              name: "MT国产高性能区块链基础平台",
            },
            {
              url: require("./../../assets/home/lableRight.png"),
              name: "国产化版本PKMT",
            },
            {
              url: require("./../../assets/home/lableRight.png"),
              name: "国产化版本KPMT",
            },
          ],
          rightList: ["区块链分布式存储网络StorNet", "区块链结构化数据库InSQL"],
        },
        {
          leftList: [
            {
              url: require("./../../assets/home/lableRight.png"),
              name: "MTBaaS平台",
            },
            // {
            //     url:require('./../../assets/home/lableRight.png'),
            //     name:'MT国产隐私计算设备MTCal',
            // },
          ],
          rightList: [
            // 'StorNet 区块链分布式存储','HashStor 区块链分布式存储设备',
          ],
        },
        {
          leftList: [
            {
              url: require("./../../assets/home/lableLeft.png"),
              name: "兆票",
            },
            {
              url: require("./../../assets/home/lableLeft2.png"),
              name: "兆存",
            },
            {
              url: require("./../../assets/home/lableLeft3.png"),
              name: "兆源",
            },
            {
              url: require("./../../assets/home/lableLeft4.png"),
              name: "兆权",
            },
            {
              url: require("./../../assets/home/lableLeft5.png"),
              name: "兆信",
            },
            {
              url: require("./../../assets/home/lableLeft6.png"),
              name: "兆训",
            },
            {
              url: require("./../../assets/home/lableLeft7.png"),
              name: "兆易",
            },
            {
              url: require("./../../assets/home/lableLeft1.png"),
              name: "兆融",
            },
          ],
          rightList: [
            "区块链隐私计算安全服务平台MP",
            "区块链人工智能群组协同平台MTAI",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.system{
  height: 667px;
  background-color: #FAFBFC;
  padding-top: 90px;
  position: relative;
  .product{
    max-width: 1280px;
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background: url("../../assets/home/systemBG.png");
    background-size: 100% 100%;
    height: 579px;
    padding-top: 72px;
    .name{
      width: 128px;
      height: 45px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 900;
      color: #21242A;
      line-height: 45px;
      margin: 0 auto 40px auto;
    }
    .lable{
      width: 196px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      margin: 0 auto;
    }
    .content{
      width: 100%;
      /*height: 344px;*/
      background-color: #FFFFFF;
      //margin: 40px auto 0 auto;
      border-radius: 5px;
      .contentNames{
        width: 100%;
        padding-top: 28px;
        padding-left: 5px;
        display: flex;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #646C7C;
        line-height: 25px;
        .nameFor{
          width: 33%;
          text-align: center;
          span{
            position: relative;
            cursor: pointer;
            img{
              width: 55px;
              height: 66px;
              position: absolute;
              left: -60px;
              bottom: -20px;
            }
          }
        }
        .active{
          color: #282F3C;
        }
      }
      .contentLable{
        /*background-color: red;*/
        height: 133px;
        display: flex;
        margin: 50px 80px;
        .lableLeft{
          width: 50%;
          display: flex;
          flex-wrap: wrap;
          border-right: 1px solid #e2e2e2;
          div{
            margin-top: 20px;
            margin-right: 40px;
            img{
              margin-right: 10px;
            }
            span{
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #646C7C;
              line-height: 25px;
            }
          }
        }
        .lableRight{
          width: 50%;
          display: flex;
          flex-wrap: wrap;
          margin-left: 20px;
          div{
            margin-top: 20px;
            margin-right: 40px;
            img{
              margin-right: 10px;
            }
            span{
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #646C7C;
              line-height: 25px;
            }
          }
        }
      }
      .nan{
        margin-top: 50px;
        height: 33px;
        background-color: #D6EDFF;
        display: flex;
        text-align: center;
        color: #3570D9;
        line-height: 33px;
        .nanleft{
          width: 49%;
          border-right: 1px white solid;

        }
        .nanright{
          width: 50%;
        }
      }
    }
    .bgc{
      height: 26px;
      width: 100%;
      background-color: #FAFBFC;
      position: absolute;
      bottom: 0;
    }
    .img{
      position: absolute;
      bottom: 0;
      right: 42px;
    }
  }
}
</style>
